<template>
  <base-dialog
    :visible="visible"
    :show-close="true"
    width="600px"
    class="dialog-wrap"
    border-radius="none"
    @open="open"
    @closed="closed"
  >
    <template v-slot:header>
      <div class="header-wrap">{{ title }}</div>
    </template>
    <el-input
      v-model="searchText"
      placeholder="请输入搜索内容"
      clearable
      @keyup.enter.native.stop="search"
      @clear="search"
      class="search"
    >
      <div slot="prepend">搜索</div>
      <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
    </el-input>
    <div v-if="filterData.length == 0" class="empty">
      无数据
    </div>
    <div v-else class="data-list">
      <el-checkbox-group v-if="multiple" v-model="checkList">
        <el-checkbox
          v-for="(item, index) in filterData"
          :key="index"
          :label="item.value"
          :title="item.label"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
      <el-radio-group v-else v-model="checkOne">
        <el-radio
          v-for="(item, index) in filterData"
          :key="index"
          :label="item.value"
          :title="item.label"
        >
          {{ item.label }}
        </el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <base-button @click="closed">取 消</base-button>
      <base-button type="primary" @click="submit">确 定</base-button>
    </span>
  </base-dialog>

  <!-- </el-dialog> -->
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "select-dialog",
  components: {
    BaseDialog,
    BaseButton
  },
  props: {
    visible: Boolean,
    type: String,
    selected: Array,
    selectList: Array,
    multiple: Boolean
  },
  data() {
    return {
      checkList: [],
      checkOne: "",
      searchText: "",
      canSelect: [],
      filterData: []
    }
  },
  computed: {
    title() {
      if (this.type == "user") return "选择人员"
      else if (this.type == "role") return "选择角色"
      return ""
    }
  },
  methods: {
    open() {
      if (this.selected?.length) {
        let selectedIds = this.selected.map(i => i.code)
        this.canSelect = this.selectList.filter(i => !selectedIds.includes(i.value))
      } else this.canSelect = this.selectList
      this.filterData = this.canSelect
    },
    closed() {
      this.$emit("update:visible", false)
      this.searchText = ""
    },
    hideDialog() {
      this.$emit("update:dialogVisible", false)
    },
    submit() {
      if (this.multiple) {
        let checkList = []
        this.selectList.forEach(i => {
          if (this.checkList.includes(i.value)) checkList.push(i)
        })
        this.$emit("select", checkList)
      } else {
        let checkOne = this.selectList.find(i => i.value == this.checkOne)
        this.$emit("select", checkOne)
      }
      this.clearData()
      this.closed()
    },
    clearData() {
      Object.assign(this.$data, this.$options.data())
    },
    search() {
      this.filterData = this.selectList.filter(i => i.label.includes(this.searchText))
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  ::v-deep {
    .el-dialog__body {
      padding: 14px 22px !important;
    }
  }
  .loading-container {
    height: 200px;
  }
  .empty {
    text-align: center;
    line-height: 100px;
    color: #c0c4cc;
  }
  .search {
    width: 360px;
    margin-bottom: 10px;
    text-align: right;
    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }
  .data-list {
    margin-top: 10px;
    min-height: 80px;
    max-height: calc(80vh - 110px - 50px);
    overflow: auto;
    .el-checkbox-group,
    .el-radio-group {
      padding-left: 4px;
    }
    // 单选和多选的单个元素
    .el-checkbox,
    .el-radio {
      display: inline-flex;
      align-items: center;
      height: 30px;
      margin-right: 20px;
    }
    ::v-deep .el-checkbox__label,
    ::v-deep .el-radio__label {
      display: inline-block;
      width: 94px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
